import { render, staticRenderFns } from "./production.vue?vue&type=template&id=3a82fbcc&scoped=true&"
import script from "./production.vue?vue&type=script&lang=js&"
export * from "./production.vue?vue&type=script&lang=js&"
import style0 from "./production.vue?vue&type=style&index=0&id=3a82fbcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a82fbcc",
  null
  
)

export default component.exports